import { render } from "./IconBase.vue?vue&type=template&id=6492d288"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"
script.render = render

export default script